export default {
  PDFButtonFab: {
    baixar: 'Download',
    enviarEmail: 'Send by email',
    baixarPDF: 'Download PDF',
    baixarXLS: 'Download XLS',
    baixando: 'Downloading'
  }
};
